import React from 'react';
import PropTypes from 'prop-types';
import { at } from 'lodash';
import { useField, useFormikContext } from 'formik';
import { Autocomplete, FormHelperText, TextField } from '@mui/material';
import { bool, boolean } from 'yup';

function AutocompleteField(props: any) {
  const {
    label,
    options,
    onChange,
    element,
    noOptionsText = 'No hay opciones disponibles',
    loading = false,
    loadingText = 'Cargando...',
    ...rest
  } = props;
  const formikProps = useFormikContext();

  const [field, meta, isdisabled] = useField(props);

  const { value: selectedValue } = field;
  const [touched, error] = at(meta, 'touched', 'error');
  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');

    if (touched && error) {
      if (typeof error === 'object' && error !== null) {
        return Object.values(error).find((v) => typeof v === 'string') || 'Campo requerido';
      }
      return error;
    }
    if (touched && props.required && (!selectedValue || selectedValue === '')) {
      return 'Campo requerido';
    }
  }

  return (
    <Autocomplete
      fullWidth={rest.fullWidth}
      disabled={rest.disabled}
      onBlur={() => formikProps.setFieldTouched(field.name)}
      loading={loading}
      loadingText={loadingText}
      noOptionsText={noOptionsText}

      onChange={(event, v) => {
        formikProps.setFieldValue(field.name, v);
        if (onChange) onChange(event, v);
      }}
      value={selectedValue || null}
      options={options}
      isOptionEqualToValue={(option: any, val: any) =>
        option?.value === val?.value || option?.id === val?.id || option === val
      }
      getOptionLabel={(option: any) => {
        if (typeof option === 'string') return option;
        if (option && typeof option === 'object') {
          return option.label || option.type_document || option.name || option.workplace || '';
        }
        return '';
      }}
      getOptionDisabled={(option: any) => !!option.isDisabled}
      renderOption={(props, option: any) => (
        <li {...props} key={option.value || option.id}>
          {option.label || option.type_document || option.name || ''}
        </li>
      )}
      disablePortal
      renderInput={(params) => (
        <TextField
          {...params}
          helperText={_renderHelperText()}
          {...rest}
          label={label}
          error={Boolean(
            (touched && error) ||
            (touched && props.required && (!selectedValue || selectedValue === ''))
          )}
        />
      )}
    />

    // <Autocomplete
    //     onBlur={() => formikProps.setFieldTouched(field.name) }
    //     loading={true}
    //     loadingText={'Cargando...'}
    //     onChange={ (e,v) => formikProps.setFieldValue(field.name, v) }
    //     value={selectedValue ? selectedValue : ''}
    //     renderOption={(props, option:any) => {
    //       return (
    //         <li {...props} key={option.value}>
    //           {option.label}
    //         </li>
    //       );
    //     }}
    //     disablePortal
    //     options={options}
    //     renderInput={(params) => <TextField
    //                                  key={params.id}
    //                                  helperText={_renderHelperText()}
    //                                 {...params}
    //                                 {...rest}
    //                                 label={label}
    //                                 error={touched && error}
    //                               />}
    // />
  );
}

AutocompleteField.defaultProps = {
  options: [],
  name: '',
  label: '',
  setValue: '',
  element: '',
  isdisabled: boolean,
  onChange: () => {},
};

export default AutocompleteField;
